import { render, staticRenderFns } from "./TcoPerks.vue?vue&type=template&id=36fee5bd"
import script from "./TcoPerks.vue?vue&type=script&lang=js"
export * from "./TcoPerks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports